<template>
  <div>
    <b-container style="padding: 80px 0">
      <b-row>
        <b-col sm="12">
          <h2 class="styled-title">What We Offer</h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          sm="3"
          class="service-card-1"
          v-for="item in data"
          :key="item.id"
        >
          <b-row>
            <b-col cols="3">
              <b-icon :icon="item.icon" font-scale="3" variant="primary">
              </b-icon>
            </b-col>
            <b-col cols="9">
              <h5 class="service-card-title">{{ item.title }}</h5>
              <h3 class="service-card-subtitle">{{ item.title2 }}</h3>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <article class="inner-box">
                <div class="text">
                  <div style="min-height: 170px;">
                    {{ item.description.substring(0, 150) }}...
                  </div>
                </div>
                <div class="knowmore">
                  <span>
                    <router-link :to="'service/' + item.route">
                      Know More
                      <b-icon icon="arrow-right"></b-icon>
                    </router-link>
                  </span>
                </div>
              </article>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { db } from "../firebase/db";
export default {
  data() {
    return {
      drawer: true,
      data: []
    };
  },
  firestore: {
    data: db.collection("homeServices").orderBy("sortId")
  }
};
</script>

<style lang="scss" scoped></style>
